import { css } from '@emotion/core'

export const label = css`
  position: absolute;
`
